import DownType from "./down-type";

const PatDownType = Object.freeze({
    Normal: DownType.Normal,
    LossOfDownOnPLay: DownType.LossOfDownOnPLay
});

export default PatDownType;
